import CommonService from "./common.service";

const BASE = "/me";

export const myDisputeExtractMessage = (err, fallback = "Request failed") =>
  err?.response?.data?.message || err?.response?.data?.error || err?.message || fallback;

export const fetchMyDisputes = async (params = {}) => {
  const res = await CommonService.get(`${BASE}/disputes`, params, { silent: true });
  return res?.data ?? { items: [], total: 0, page: 1, pageSize: 10 };
};

export const fetchMyDisputeStats = async () => {
  const res = await CommonService.get(`${BASE}/disputes/stats`, {}, { silent: true });
  return (
    res?.data ?? {
      total: 0,
      inProgress: 0,
      resolved: 0,
      closed: 0,
    }
  );
};

export const fetchMyDisputeById = async (id) => {
  const res = await CommonService.get(`${BASE}/disputes/${id}`, {}, { silent: true });
  return res?.data ?? null;
};

export const postMyDisputeMessage = async (id, { message, attachment }) => {
  const form = new FormData();
  form.append("message", message || "");
  if (attachment) form.append("attachment", attachment);
  const res = await CommonService.post(`${BASE}/disputes/${id}/messages`, form, { silent: true });
  return res?.data?.message ?? null;
};

export const MY_DISPUTE_STATUS_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "new", label: "New" },
  { value: "assigned", label: "Assigned" },
  { value: "in_progress", label: "In Progress" },
  { value: "waiting_buyer", label: "Waiting for Buyer" },
  { value: "waiting_seller", label: "Waiting for Seller" },
  { value: "under_investigation", label: "Under Investigation" },
  { value: "resolved", label: "Resolved" },
  { value: "closed", label: "Closed" },
  { value: "reopened", label: "Reopened" },
];

export const MY_DISPUTE_PRIORITY_OPTIONS = [
  { value: "", label: "All Priorities" },
  { value: "Low", label: "Low" },
  { value: "Medium", label: "Medium" },
  { value: "High", label: "High" },
  { value: "Urgent", label: "Urgent" },
];

export const DISPUTE_CATEGORY_VALUES = [
  "Late Delivery",
  "Damaged Goods",
  "Wrong Item",
  "Quality Issue",
  "Quantity Mismatch",
  "Payment Delay",
  "Refund Pending",
  "Service Issue",
  "Logistics Issue",
  "Other",
];

export const MY_DISPUTE_CATEGORY_OPTIONS = [
  { value: "", label: "All Categories" },
  ...DISPUTE_CATEGORY_VALUES.map((value) => ({ value, label: value })),
];
